var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { makeObservable, action, observable } from 'mobx';
import { organizationGroupApi } from './organization-group-api';
var OrganizationGroupStore = /** @class */ (function () {
    function OrganizationGroupStore() {
        // properties
        Object.defineProperty(this, "isBusy", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "caseTypes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        Object.defineProperty(this, "users", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        Object.defineProperty(this, "groups", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        Object.defineProperty(this, "organizationId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        makeObservable(this);
        window.$OrganizationGroupStore = this;
    }
    // methods
    Object.defineProperty(OrganizationGroupStore.prototype, "setBusy", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.isBusy = true;
        }
    });
    Object.defineProperty(OrganizationGroupStore.prototype, "setNotBusy", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.isBusy = false;
        }
    });
    Object.defineProperty(OrganizationGroupStore.prototype, "initializeGroups", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (groups, users, caseTypes) {
            var _this = this;
            var _loop_1 = function (group) {
                group.isEditUsers = false;
                group.users = users.map(function (user) { return (__assign(__assign({}, user), { isSelected: _this.isUserAssigned(user, group) })); });
                group.caseTypes = caseTypes.map(function (caseType) { return (__assign(__assign({}, caseType), { isSelected: _this.isCaseTypeAssigned(group, caseType) })); });
            };
            for (var _i = 0, groups_1 = groups; _i < groups_1.length; _i++) {
                var group = groups_1[_i];
                _loop_1(group);
            }
            this.groups = groups;
        }
    });
    Object.defineProperty(OrganizationGroupStore.prototype, "isUserAssigned", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (user, group) {
            return group.users.some(function (u) { return u.id === user.id; });
        }
    });
    Object.defineProperty(OrganizationGroupStore.prototype, "isCaseTypeAssigned", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (group, caseType) {
            return group.caseTypes.some(function (ct) { return ct.id === caseType.id; });
        }
    });
    Object.defineProperty(OrganizationGroupStore.prototype, "setGroups", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (groups) {
            this.groups = groups;
        }
    });
    Object.defineProperty(OrganizationGroupStore.prototype, "setOrganizationUsers", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (users) {
            this.users = users;
        }
    });
    Object.defineProperty(OrganizationGroupStore.prototype, "setOrganizationCaseTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseTypes) {
            this.caseTypes = caseTypes;
        }
    });
    // async methods
    Object.defineProperty(OrganizationGroupStore.prototype, "removeGroup", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.setBusy();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 4, 5]);
                            return [4 /*yield*/, organizationGroupApi.deleteGroup(id)];
                        case 2:
                            if (!(_a.sent()))
                                alert('Error');
                            return [4 /*yield*/, this.init(this.organizationId)];
                        case 3:
                            _a.sent();
                            return [3 /*break*/, 5];
                        case 4:
                            this.setNotBusy();
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(OrganizationGroupStore.prototype, "updateGroup", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (group, groups) {
            return __awaiter(this, void 0, void 0, function () {
                var updatedGroup;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, organizationGroupApi.updateGroup(group)];
                        case 1:
                            updatedGroup = _a.sent();
                            this.setGroups(groups);
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(OrganizationGroupStore.prototype, "init", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id) {
            return __awaiter(this, void 0, void 0, function () {
                var users, caseTypes, groups, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.setBusy();
                            this.organizationId = id;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 5, 6, 7]);
                            return [4 /*yield*/, organizationGroupApi.getOrganizationUsers(id)];
                        case 2:
                            users = _a.sent();
                            // set organization users: 
                            this.setOrganizationUsers(users);
                            return [4 /*yield*/, organizationGroupApi.getOrganizationCaseTypes(id)];
                        case 3:
                            caseTypes = _a.sent();
                            this.setOrganizationCaseTypes(caseTypes);
                            return [4 /*yield*/, organizationGroupApi.getGroups(id)];
                        case 4:
                            groups = _a.sent();
                            this.initializeGroups(groups, users, caseTypes);
                            return [3 /*break*/, 7];
                        case 5:
                            error_1 = _a.sent();
                            console.log("Error:" + error_1);
                            return [3 /*break*/, 7];
                        case 6:
                            this.setNotBusy();
                            return [7 /*endfinally*/];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(OrganizationGroupStore.prototype, "getGroups", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (organizationId) {
            return __awaiter(this, void 0, void 0, function () {
                var items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.setBusy();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            return [4 /*yield*/, organizationGroupApi.getGroups(organizationId)];
                        case 2:
                            items = _a.sent();
                            this.setGroups(items);
                            return [3 /*break*/, 4];
                        case 3:
                            this.setNotBusy();
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(OrganizationGroupStore.prototype, "addGroup", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (organizationId, name) {
            return __awaiter(this, void 0, void 0, function () {
                var newGroup_1;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.setBusy();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            return [4 /*yield*/, organizationGroupApi.addGroup(organizationId, name)];
                        case 2:
                            newGroup_1 = _a.sent();
                            newGroup_1.isEditUsers = false;
                            newGroup_1.users = this.users.map(function (user) { return (__assign(__assign({}, user), { isSelected: _this.isUserAssigned(user, newGroup_1) })); });
                            newGroup_1.caseTypes = this.caseTypes.map(function (caseType) { return (__assign(__assign({}, caseType), { isSelected: _this.isCaseTypeAssigned(newGroup_1, caseType) })); });
                            this.groups.push(newGroup_1);
                            return [3 /*break*/, 4];
                        case 3:
                            this.setNotBusy();
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(OrganizationGroupStore.prototype, "setUserGroup", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (groupIndex, userIndex) {
            return __awaiter(this, void 0, void 0, function () {
                var group, user, payload, error_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            group = this.groups[groupIndex];
                            user = group.users[userIndex];
                            user.isSelected = !user.isSelected;
                            payload = {
                                userId: user.id,
                                assigned: user.isSelected,
                            };
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, organizationGroupApi.setUserGroup(group.id, payload)];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            error_2 = _a.sent();
                            console.error('Error changing user check status:', error_2);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(OrganizationGroupStore.prototype, "setGroupCaseType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (groupIndex, caseTypeIndex) {
            return __awaiter(this, void 0, void 0, function () {
                var group, caseType, payload, error_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            group = this.groups[groupIndex];
                            caseType = group.caseTypes[caseTypeIndex];
                            caseType.isSelected = !caseType.isSelected;
                            payload = {
                                caseTypeId: caseType.id,
                                assigned: caseType.isSelected,
                            };
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, organizationGroupApi.setGroupCaseType(group.id, payload)];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            error_3 = _a.sent();
                            console.error('Error changing case type check status:', error_3);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
    });
    __decorate([
        observable
    ], OrganizationGroupStore.prototype, "isBusy", void 0);
    __decorate([
        observable
    ], OrganizationGroupStore.prototype, "caseTypes", void 0);
    __decorate([
        observable
    ], OrganizationGroupStore.prototype, "users", void 0);
    __decorate([
        observable
    ], OrganizationGroupStore.prototype, "groups", void 0);
    __decorate([
        observable
    ], OrganizationGroupStore.prototype, "organizationId", void 0);
    __decorate([
        action
    ], OrganizationGroupStore.prototype, "setBusy", null);
    __decorate([
        action
    ], OrganizationGroupStore.prototype, "setNotBusy", null);
    __decorate([
        action
    ], OrganizationGroupStore.prototype, "initializeGroups", null);
    __decorate([
        action
    ], OrganizationGroupStore.prototype, "isUserAssigned", null);
    __decorate([
        action
    ], OrganizationGroupStore.prototype, "isCaseTypeAssigned", null);
    __decorate([
        action
    ], OrganizationGroupStore.prototype, "setGroups", null);
    __decorate([
        action
    ], OrganizationGroupStore.prototype, "setOrganizationUsers", null);
    __decorate([
        action
    ], OrganizationGroupStore.prototype, "setOrganizationCaseTypes", null);
    __decorate([
        action
    ], OrganizationGroupStore.prototype, "removeGroup", null);
    __decorate([
        action
    ], OrganizationGroupStore.prototype, "updateGroup", null);
    __decorate([
        action
    ], OrganizationGroupStore.prototype, "init", null);
    __decorate([
        action
    ], OrganizationGroupStore.prototype, "getGroups", null);
    __decorate([
        action
    ], OrganizationGroupStore.prototype, "addGroup", null);
    __decorate([
        action
    ], OrganizationGroupStore.prototype, "setUserGroup", null);
    __decorate([
        action
    ], OrganizationGroupStore.prototype, "setGroupCaseType", null);
    return OrganizationGroupStore;
}());
export default OrganizationGroupStore;
